import {
  DASHBOARD_POSICAO_VIEWS_CHANGED,
  DASHBOARD_POSICAO_VIEW_SELECTED,
  DASHBOARD_POSICAO_DATES_CHANGED,
  DASHBOARD_POSICAO_DATE_SELECTED,
  DASHBOARD_POSICAO_CURRENT_KEY_CHANGED,
  DASHBOARD_POSICAO_REQUEST_STARTED,
  DASHBOARD_POSICAO_REQUEST_SUCCEEDED,
  DASHBOARD_POSICAO_REQUEST_FAILED,
  DASHBOARD_POSICAO_CACHE_INVALIDATED,
  ENTIDADE_CURRENT_CHANGED,
  ENTIDADE_LOGOUT
} from '../../const/actionsType';

const INITIAL_STATE = {
  posicao: {
    filters: {
      views: [],
      selectedViewId: null,
      availableDatesByView: {},
      selectedDateByView: {}
    },
    cacheByKey: {},
    requestsByKey: {},
    currentKey: null
  }
};

/**
 * Atualiza os filtros da posição preservando o restante do slice.
 * @param {Object} pState - Estado atual do reducer
 * @param {Object} pFilters - Campos de filtros a serem mesclados
 * @returns {Object}
 */
function updatePosicaoFilters(pState, pFilters) {
  return {
    ...pState,
    posicao: {
      ...pState.posicao,
      filters: {
        ...pState.posicao.filters,
        ...pFilters
      }
    }
  };
}

/**
 * Cria o payload padrão de controle de request por chave de cache.
 * @param {string} pStatus - Status da request
 * @param {number|string} pRequestId - Identificador da request
 * @param {*} pError - Erro associado à request
 * @returns {Object}
 */
function createRequestState(pStatus, pRequestId, pError = null) {
  return {
    status: pStatus,
    error: pError,
    requestId: pRequestId,
    updatedAt: Date.now()
  };
}

function dashboardReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case DASHBOARD_POSICAO_VIEWS_CHANGED:
      return updatePosicaoFilters(state, {
        views: Array.isArray(action.payload) ? action.payload : []
      });
    case DASHBOARD_POSICAO_VIEW_SELECTED:
      return updatePosicaoFilters(state, {
        selectedViewId: action.payload
      });
    case DASHBOARD_POSICAO_DATES_CHANGED: {
      const { viewId, dates } = action.payload;

      return updatePosicaoFilters(state, {
        availableDatesByView: {
          ...state.posicao.filters.availableDatesByView,
          [viewId]: dates
        }
      });
    }
    case DASHBOARD_POSICAO_DATE_SELECTED: {
      const { viewId, date } = action.payload;

      return updatePosicaoFilters(state, {
        selectedDateByView: {
          ...state.posicao.filters.selectedDateByView,
          [viewId]: date
        }
      });
    }
    case DASHBOARD_POSICAO_CURRENT_KEY_CHANGED:
      return {
        ...state,
        posicao: {
          ...state.posicao,
          currentKey: action.payload
        }
      };
    case DASHBOARD_POSICAO_REQUEST_STARTED: {
      const { cacheKey, requestId } = action.payload;

      return {
        ...state,
        posicao: {
          ...state.posicao,
          requestsByKey: {
            ...state.posicao.requestsByKey,
            [cacheKey]: createRequestState('loading', requestId)
          }
        }
      };
    }
    case DASHBOARD_POSICAO_REQUEST_SUCCEEDED: {
      const { cacheKey, requestId, data, fetchedAt } = action.payload;
      const currentRequest = state.posicao.requestsByKey[cacheKey];

      if (currentRequest?.requestId !== requestId) {
        return state;
      }

      return {
        ...state,
        posicao: {
          ...state.posicao,
          cacheByKey: {
            ...state.posicao.cacheByKey,
            [cacheKey]: {
              data,
              fetchedAt
            }
          },
          requestsByKey: {
            ...state.posicao.requestsByKey,
            [cacheKey]: createRequestState('success', requestId)
          }
        }
      };
    }
    case DASHBOARD_POSICAO_REQUEST_FAILED: {
      const { cacheKey, requestId, error } = action.payload;
      const currentRequest = state.posicao.requestsByKey[cacheKey];

      if (currentRequest?.requestId !== requestId) {
        return state;
      }

      return {
        ...state,
        posicao: {
          ...state.posicao,
          requestsByKey: {
            ...state.posicao.requestsByKey,
            [cacheKey]: createRequestState('error', requestId, error)
          }
        }
      };
    }
    case DASHBOARD_POSICAO_CACHE_INVALIDATED: {
      const cacheKey = action.payload;

      if (!cacheKey) {
        return {
          ...state,
          posicao: {
            ...state.posicao,
            cacheByKey: {},
            requestsByKey: {}
          }
        };
      }

      const nextCacheByKey = { ...state.posicao.cacheByKey };
      const nextRequestsByKey = { ...state.posicao.requestsByKey };

      delete nextCacheByKey[cacheKey];
      delete nextRequestsByKey[cacheKey];

      return {
        ...state,
        posicao: {
          ...state.posicao,
          cacheByKey: nextCacheByKey,
          requestsByKey: nextRequestsByKey
        }
      };
    }
    case ENTIDADE_CURRENT_CHANGED:
    case ENTIDADE_LOGOUT:
      return {
        ...INITIAL_STATE
      };
    default:
      return state;
  }
}

export default dashboardReducer;
